import {
  AppleIcon,
  GithubIcon,
  Odnoklassniki,
  TBankIcon,
  VkIcon,
  YandexIcon,
  AlfaIcon,
} from '@lt/components/icons-react/auth';
import React from 'react';
import type { SocialNetworkNames } from '../../utils/socialNetworkUtils';

export interface SocialAuthMethods {
  icon: React.ReactNode | JSX.Element;
  networkName: SocialNetworkNames;
  isShow: boolean;
}

const getIsTinkoffAndTestWl = () => {
  try {
    const host = window.location.hostname;
    return (
      host === 'staging-epsilon.level.travel' ||
      host === 'staging-prod2.level.travel' ||
      host === 'staging-wl.level.travel' ||
      host === 'tbank.level.travel' ||
      host === 'tbank-tours.level.travel' ||
      host === 'tbank-hotels.level.travel'
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  return false;
};

const getIsAlfaAndTestWl = () => {
  try {
    const host = window.location.hostname;
    return (
      host === 'staging-epsilon.level.travel' ||
      host === 'staging-prod2.level.travel' ||
      host === 'staging-wl.level.travel' ||
      host === 'alfatest.level.travel'
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  return false;
};

const isWebView = window.is_webview || false;

export const getSocialAuthMethods = (isWl = false): SocialAuthMethods[] => [
  {
    icon: <TBankIcon width={32} height={32} />,
    networkName: 'tbank',
    isShow: !isWl || getIsTinkoffAndTestWl(),
  },
  {
    icon: <VkIcon width={32} height={32} />,
    networkName: 'vk',
    isShow: !isWl,
  },
  {
    icon: <YandexIcon width={32} height={32} />,
    networkName: 'yandex',
    isShow: !isWl,
  },
  {
    icon: <AlfaIcon width={32} height={32} />,
    networkName: 'alfabank',
    isShow: (!isWl || getIsAlfaAndTestWl()) && !isWebView,
  },
  {
    icon: <Odnoklassniki width={33} height={33} />,
    networkName: 'ok',
    isShow: false,
  },
  {
    icon: <AppleIcon width={33} height={33} />,
    networkName: 'apple',
    isShow: false,
  },
  {
    icon: <GithubIcon width={33} height={33} />,
    networkName: 'github',
    isShow: false,
  },
];
